import React, {Component} from 'react';
import 'react-select/dist/react-select.css';
import Select from 'react-select';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as companyActions from "../../actions/companyActions";
import * as regionActions from "../../actions/regionActions";
import * as addressSearchActions from "../../actions/addressSearchActions";
import * as companyMunicipalitiesActions from "../../actions/companyMunicipalityActions";



class Regions extends React.Component {
    constructor(props) {
        super(props)
    }
    onChange(regionId) {
        if (this.props.input.onChange && regionId !== null) {
            this.props.input.onChange(regionId);
            this.props.actions.updateSelectedRegionId(regionId);
            this.props.actions.clearCompanyAddressSearchResults();
            this.props.actions.clearCompanyCityInformation();
        } else {
            this.props.input.onChange(null)
        }
    }

    render() {
        return (
            <Select
                {...this.props}
                value={this.props.input.value}
                options={this.props.regions}
                onChange={ this.onChange.bind(this)}
                simpleValue={true}
                clearable={false}
                placeholder='Vælg region'
                isLoading={this.props.regions.length === 0}
                onBlur={() => this.props.input.onBlur(this.props.input.value)}
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                companyActions,
                regionActions,
                addressSearchActions,
                companyMunicipalitiesActions
            ), dispatch
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Regions);




// WEBPACK FOOTER //
// ./web/src/components/company/Regions.jsx